<template>
  <a class="button" href="#!" @click.prevent="saveProduct">Add items to Project Book</a>
</template>
<script>
import { eventBus } from '../app';

export default {
    props: {},
    data() {
        return {
        };
    },
    methods: {
        saveProduct() {
            let items = $('[data-pb-multiple-items]').data('pbMultipleItems');
            eventBus.$emit('save-multiple-products', { items });
        }
    }
};
</script>
